import React from 'react';
import { MiddleSideMobile } from '../MiddleSideMobile/MiddleSideMobile';
import { HeaderMobile } from './HeaderMobile';
import { NavigationMobile } from './NavigationMobile';
import { BottomNav } from './BottomNav';

export const Mobile: React.FC = () => {
  return (
    <>
      <HeaderMobile />
      <NavigationMobile />

      <div className='laptop:hidden flex flex-1 justify-center overflow-scroll no-scrollbar pb-16'>
        <MiddleSideMobile />
      </div>
      <BottomNav />
    </>
  );
};